import { MembersModel } from '../models/members.model';
import RequestCreator from './helpers/requestCreator';

class Member extends RequestCreator<MembersModel> {}

const api = new Member('/members');
export default api;
